module.exports = __webpack_public_path__ + "media/Audio19_g.0fe4f2df.wav";